var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25.999px",
    height: "25.993px",
    viewBox: "259.986 -21.008 25.999 25.993",
    enableBackground: "new 259.986 -21.008 25.999 25.993",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009044",
    d: "M285.479-16.746c-1.313-1.33-2.656-2.633-3.99-3.944c-0.257-0.252-0.567-0.372-0.935-0.296 c-0.406,0.083-0.674,0.324-0.794,0.71c-0.129,0.415,0.015,0.763,0.314,1.058c0.729,0.718,2.139,2.106,2.55,2.511 c-0.752,0.005-1.809,0.012-1.933,0.017c-3.731,0.131-7.2,1.677-9.801,4.333c-2.607,2.662-4.043,6.108-4.043,9.896h2.055 c0-6.627,5.199-11.955,11.859-12.188c0.12-0.003,1.18-0.017,1.924-0.026l-0.008,0.219c0,0-1.758,1.707-2.609,2.561 c-0.465,0.466-0.46,1.073-0.025,1.485c0.423,0.401,1.009,0.397,1.467-0.051c1.325-1.296,2.648-2.595,3.951-3.913 C286.151-15.073,286.163-16.053,285.479-16.746z M277.855,1.19c-0.103,0-0.208,0.014-0.308-0.002 c-0.491-0.083-0.641,0.1-0.621,0.598c0.041,1.002-0.28,1.29-1.304,1.29c-4.143,0.001-8.285,0.001-12.428,0 c-0.99,0-1.272-0.283-1.272-1.271c-0.001-3.955-0.001-7.91-0.001-11.864c0-1.529,0.025-1.562,1.578-1.688 c0.215-0.018,0.304-0.075,0.298-0.295c-0.012-0.439-0.006-0.879-0.002-1.318c0.001-0.172-0.038-0.267-0.246-0.301 c-1.895-0.307-3.552,1.042-3.557,2.94c-0.011,4.242-0.008,8.484-0.001,12.727c0.003,1.787,1.218,2.972,3.039,2.977 c2.14,0.006,4.28,0.001,6.42,0.001s4.279,0.005,6.419-0.002c1.648-0.006,2.827-1.068,2.989-2.675 C278.973,1.19,278.973,1.19,277.855,1.19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend01);
export default __webpack_public_path__ + "static/media/send-01.32d71f77a86aaae2e10b7df1ac1eed6b.svg";
export { ForwardRef as ReactComponent };